var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28125 10.1563C6.24543 10.1563 7.18797 9.87034 7.98965 9.33467C8.79134 8.79899 9.41619 8.03762 9.78516 7.14683C10.1541 6.25604 10.2507 5.27584 10.0626 4.33019C9.87448 3.38453 9.41018 2.51589 8.7284 1.83411C8.04661 1.15233 7.17797 0.688027 6.23232 0.499924C5.28666 0.311821 4.30646 0.408362 3.41567 0.777339C2.52488 1.14632 1.76351 1.77116 1.22784 2.57285C0.692164 3.37454 0.40625 4.31707 0.40625 5.28125C0.40625 6.08725 0.60125 6.84667 0.947917 7.51671L0.40625 10.1563L3.04579 9.61459C3.71529 9.96071 4.47579 10.1563 5.28125 10.1563Z",
    stroke: "#262F5F",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.b6c351eea955ce05c6d238c49fbb81d1.svg";
export { ForwardRef as ReactComponent };